import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

/**
 * @private
 *
 * Boundary to prevent rendering of nested components during SSR. (This is necessary for
 * components that access DOM elements, e.g., component adds a portal element to the DOM.)
 *
 */
var OverlaySsrBoundary = function OverlaySsrBoundary(props) {
  var children = props.children;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isSafeToRender = _React$useState2[0],
    setIsSafeToRender = _React$useState2[1];
  React.useEffect(function () {
    setIsSafeToRender(true);
  }, []);

  // For an explanation of this eslint-disable, see: https://github.com/jsx-eslint/eslint-plugin-react/blob/master/docs/rules/jsx-no-useless-fragment.md#allowexpressions
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return isSafeToRender ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
};

export { OverlaySsrBoundary };
